import { useState } from "react";
import SignatureStyle from "../SignatureStyle";
import CustomSignatureField from "./CustomSignatureField";
import GenerateSignatureField from "./GenerateSignatureField";
import UploadSignatureField from "./UploadSignatureField";

const SignatureSidebar = ({ signingMode }) => {
  const [signatureMode, setSignatureMode] = useState("draw");
  const [fontSettings, setFontSettings] = useState({
    fontType: "Arial",
    fontSize: "14",
    fontColor: "#000000",
  });

  const [customFields, setCustomFields] = useState([]);
  
  return (
    <div
      style={{
        flex: 1,
        border: "1px solid #ccc",
        padding: "15px",
        backgroundColor: "#f9f9f9",
        maxHeight: "80vh",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {signingMode === "all_pages" && (
        <div
          style={{
            marginBottom: "15px",
            padding: "10px",
            backgroundColor: "#fff3cd",
            color: "#856404",
            border: "1px solid #ffeeba",
            borderRadius: "4px",
          }}
        >
          Note: You have to sign on all pages of the document. Please check
          where you want to sign.
        </div>
      )}

      <div style={{ marginBottom: "15px" }}>
        <label style={{ marginRight: "10px" }}>
          <input
            type="radio"
            name="signatureMode"
            value="draw"
            checked={signatureMode === "draw"}
            onChange={() => setSignatureMode("draw")}
          />
          &nbsp;Draw
        </label>

        <label style={{ marginRight: "10px" }}>
          <input
            type="radio"
            name="signatureMode"
            value="type"
            checked={signatureMode === "type"}
            onChange={() => setSignatureMode("type")}
          />
          &nbsp;Type
        </label>

        <label>
          <input
            type="radio"
            name="signatureMode"
            value="upload"
            checked={signatureMode === "upload"}
            onChange={() => setSignatureMode("upload")}
          />
          &nbsp;Upload
        </label>
      </div>

      {/* Conditional rendering based on mode */}
      <div style={{ flex: 1 }}>
        {signatureMode === "draw" && <GenerateSignatureField />}

        {signatureMode === "type" && (
          <>
            <CustomSignatureField
              customFields={customFields}
              setCustomFields={setCustomFields}
            />
            <SignatureStyle
              fontSettings={fontSettings}
              setFontSettings={setFontSettings}
            />
          </>
        )}

        {signatureMode === "upload" && (
          <>
            <UploadSignatureField />
            <SignatureStyle
              fontSettings={fontSettings}
              setFontSettings={setFontSettings}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SignatureSidebar;
